export const scrooToElement = (ref: React.RefObject<HTMLInputElement | HTMLDivElement> | React.RefObject<HTMLInputElement> | React.RefObject<HTMLDivElement>, block: 'start' | 'center' = 'center') => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: block })
}
